import React, { ReactNode } from "react";
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import Navbar from "./Navbar";
import { AppSidebar } from "../navigation/AppSidebar";
import Breadcrumbs from "./Breadcrumbs";
import ImpersonationBanner from "./ImpersonationBanner";

interface AppLayoutProps {
  children: ReactNode;
  showBreadcrumbs?: boolean;
}

const AppLayout = ({ children, showBreadcrumbs = true }: AppLayoutProps) => {
  return (
    <SidebarProvider>
      <div className="h-screen flex w-full max-w-full overflow-hidden">
        <AppSidebar />
        <SidebarInset className="flex-1 min-w-0 h-screen !min-h-0 overflow-hidden flex flex-col">
          <ImpersonationBanner />
          <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-2 border-b px-4 min-w-0 bg-background">
            <SidebarTrigger className="-ml-1 flex-shrink-0" />
            <Separator orientation="vertical" className="mr-2 h-4 flex-shrink-0" />
            <div className="min-w-0 flex-1">
              <Navbar />
            </div>
          </header>
          {/* Breadcrumbs bar */}
          {showBreadcrumbs && (
            <div className="shrink-0 border-b bg-muted/30 px-4 py-2">
              <Breadcrumbs />
            </div>
          )}
          <div className="flex-1 min-h-0 p-2 sm:p-4 md:p-6 min-w-0 max-w-full overflow-y-auto overflow-x-hidden">
            {children}
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AppLayout;
